module.exports = __webpack_public_path__ + "img/0.b6c6aabe.jpg";